type CheckboxProps = React.ComponentProps<'input'> & {
  labelProps?: React.ComponentProps<'label'>
}

export const Checkbox = ({ labelProps, children, ...props }: CheckboxProps) => {
  return (
    <label className="flex items-center cursor-pointer" {...labelProps}>
      <input
        type="checkbox"
        className="mr-8 w-[20px] h-[20px] checked:before:content-checked bg-transparent rounded-sm border border-ui-2 checked:bg-primary-gradient"
        {...props}
      />
      {children}
    </label>
  )
}
